<script lang="ts">
    import {createEventDispatcher} from 'svelte'
    import translate from '../../../../lib/translate'
    import {onInput} from '../../../../lib/forms'
    import {writable} from 'svelte/store'
    import {fade} from 'svelte/transition'
    import type {ILabel} from '../../../../types'
    import {LoginResult, notificationsStore, sessionStore} from '../../stores'
    import {NotificationType} from '../../types/Bids'
    import label from './Login.translation'

    const dispatch = createEventDispatcher()
    const closePanel = () => {
        form.username.value = ''
        form.password.value = ''
        dispatch('closePanel')
    }
    const openRegisterPanel = () => {
        form.username.value = ''
        form.password.value = ''
        dispatch('openRegisterPanel')
    }
    
    let isProcessing = writable(false)
    let form = {
        invalidLabel: <ILabel|null>null,
        username: {
            value: '',
            invalidLabel: <ILabel|null>null
        },
        password: { 
            value : '',
            hidden : true,
            invalidLabel : <ILabel|null>null
        },
        autoLogin : {
            value: true
        },
    }
    
    const submitForm = () => {
        
        // client side form validation
        
        form.username.invalidLabel = form.username.value === '' ? label.enterEmail : null
        form.password.invalidLabel = form.password.value === '' ? label.enterPassword : null
        if(form.username.invalidLabel || form.password.invalidLabel) {
            return
        }
        
        isProcessing.set(true)
        
        sessionStore.login(form.username.value, form.password.value, form.autoLogin.value)
            .then(result => {
                if(result === LoginResult.authenticated) {
                    notificationsStore.add({ 
                        title: translate(label.loginSuccessful), 
                        type: NotificationType.confirmation,
                        message: translate(label.welcomeBack),
                        durationMs: 5000,
                    })
                    closePanel()
                    return
                }
                if(result === LoginResult.invalidLogin) {
                    form.invalidLabel = label.invalidLogin
                    return
                }
                if(result === LoginResult.error) {
                    form.invalidLabel = label.serverError
                    return
                }
                if(result === LoginResult.invalidToken) {
                    document.location.reload()
                    return
                }
            })
            .finally(() => {isProcessing.set(false)})
    }
</script>

<div class="auction-agent-display-login auction-agent-form">
    <span class="close" on:click={closePanel}></span>
    <h3>{translate(label.login)}</h3>
    <form action="#" 
          class="dynamic-label agent-form" 
          on:submit|preventDefault|stopPropagation={submitForm} 
          novalidate>

        {#if form.invalidLabel}
            <div class="form-error-message">
                <p>{translate(form.invalidLabel)}</p>
            </div>
        {/if}
        
        <div class="input-box input-box-email">
            <input id="agent-login-email"
                   placeholder=" "
                   name="username"
                   type="email"
                   bind:value={form.username.value}
                   on:change={() => { onInput(form.username) }}
                   on:keyup={() => { onInput(form.username) }}>
            <label for="agent-login-email">{translate(label.email)}</label>
            {#if form.username.invalidLabel}
                <p class="validation-advice" style="display:block">{translate(form.username.invalidLabel)}</p>
            {/if}
        </div>
        
        <div class="input-box input-box-password">
            {#if form.password.hidden}
                <input id="agent-login-password"
                       placeholder=" "
                       name="password"
                       type="password"
                       bind:value={form.password.value}
                       on:change={() => { onInput(form.password) }}
                       on:keyup={() => { onInput(form.password) }}>
            {:else}
                <input id="agent-login-password"
                       placeholder=" "
                       name="password"
                       type="text"
                       bind:value={form.password.value}
                       on:change={() => { onInput(form.password) }}
                       on:keyup={() => { onInput(form.password) }}>
            {/if}
            <label for="agent-login-password">{translate(label.password)}</label>
            <span class="toggle-password {form.password.hidden ? '' : 'hide'}" on:click={() => form.password.hidden=!form.password.hidden}></span>
            {#if form.password.invalidLabel}
                <p class="validation-advice" style="display:block">{translate(form.password.invalidLabel)}</p>
            {/if}
        </div>
        <a class="secondary" href="/customer/account/forgotpassword">{translate(label.forgotPassword)}</a>
        
        <div class="input-box input-box-button">
            <button id="auctions-agent-login-submit" 
                    type="submit"
            >{translate(label.login)}</button>
        </div>
        
        <p class="clear text">{translate(label.or)}</p>
        
        <span class="btn" 
              id="auctions-agent-login-registration"
              on:click={() => openRegisterPanel()}
        >{translate(label.register)}</span>
    </form>
    {#if $isProcessing}
        <div class="form-layover layover" out:fade></div>
    {/if}
</div>